import { combineReducers } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const navLocation = (
  state = {
    location: "home",
    data: {},
  },
  action
) => {
  switch (action.type) {
    case "store":
      return { location: "store", data: action.data };
    case "product":
      return { location: "product", data: "" };
    default:
      return state;
  }
};
var cache = localStorage.getItem("cart");
var dd = cache ? JSON.parse(cache) : [];
const cartReducer = (state = dd, action) => {
  localStorage.setItem("cart", JSON.stringify(state));
  switch (action.type) {
    case "add":
      if (state.length === 0) {
        localStorage.setItem("store_id", action.data.store_id);
        localStorage.setItem("cart", JSON.stringify([...state, action.data]));
        return [...state, action.data];
        // console.log('asdfg',cart,'from handle cart')
      } else {
        const previousStore = localStorage.getItem("store_id");
        if (previousStore === action.data.store_id) {
          var isPresent = false;
          state.forEach((item) => {
            console.log(item);
            if (item._id === action.data._id) {
              isPresent = true;
            }
          });
          if (isPresent) return state;
          localStorage.setItem("cart", JSON.stringify([...state, action.data]));
          return [...state, action.data];
        } else {
          localStorage.setItem("store_id", action.data.store_id);
          //   setCart([product])
          return [action.data];
        }
      }
    // return [...state,action.data]
    case "remove":
      var dd = state.filter(
        (product) => product.unique_id !== action.data.unique_id
      );
      localStorage.setItem("cart", JSON.stringify(dd));
      if (dd.length === 0) {
        localStorage.removeItem("store_id");
      }
      toast.success("Removed!", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return dd;
    case "clear":
      localStorage.removeItem("store_id");
      return [];
    case "setAdd":
      var noewww = [...state];
      noewww.forEach((proud) => {
        console.log(proud, "in minus");
        if (proud._id === action.data) {
          proud.quantity += 1;
        }
      });
      localStorage.setItem("cart", JSON.stringify(noewww));
      return noewww;
    case "setMinus":
      var noewww = [...state];
      noewww.forEach((proud) => {
        if (proud._id === action.data) {
          if (proud.quantity === 1) return state;
          proud.quantity -= 1;
        }
      });
      localStorage.setItem("cart", JSON.stringify(noewww));
      return noewww;
    default:
      return state;
  }
};

const errorHandler = (state = { error: false, message: "" }, action) => {
  switch (action.type) {
    case "setError":
      return { error: true, message: action.data.message };
    case "unsetError":
      return { error: false, message: "" };
    default:
      return { error: false, message: "" };
  }
};
const allReducers = combineReducers({
  nav1: navLocation,
  cart: cartReducer,
  error: errorHandler,
});
export default allReducers;
